
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import MapContainer from '../components/MapContainer';
import DetailsPage from '../components/Details';
import AddPage from '../components/Add';
import SignInPage from '../components/SignInPage';

const Routes = () => {
    return(
            <div>
                <Switch>
                    <Route exact path='/' component = {() => <MapContainer/>} />
                    <Route exact path='/home' component = {() => <MapContainer/>} />
                    <Route path='/add' component = {() => <AddPage />} />
                    <Route path='/view' component = {() => <DetailsPage />} />
                    <Route path='/signin' component = {() => <SignInPage />} />
                </Switch>
            </div>
    );
}

export default Routes;


// WEBPACK FOOTER //
// ./src/components/Routes.js